//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[],[[["reanalyzeOption"],"PerformAnalysis",{},1,0],[["firstObjects","secondObjects","calculationMethod"],"ReanalyzePairs",{},3,0],[["firstObjects","secondObjects"],"CreateInterferenceGeometry",{},2,0],[["firstObjects","secondObjects"],"CalculatePenetrationDepth",{},2,0],[[],"Delete",{},0,0],[[],"GetVersion",{R_:{version:''}},0,0],[["object1","object2","type","newInterference","numberOfBodies","interfBodies","point1","point2","text","interfNum","config","depthResult","depth","direction","minPoint","maxPoint"],"GetInterferenceData",{},2,0],[[],"GetResults",{R_:{results:''}},0,0],[[],"GetNumberOfInterferences",{R_:{numberOfInterferences:''}},0,0],[["object1","object2"],"DeleteInterference",{},2,0],[["object1","object2"],"GetIsPairChanged",{R_:{isChanged:''}},2,0],[["object1","object2","nextObject1","nextObject2"],"GetNextInterference",{},2,0],[["name","mode"],"Copy",{R_:{newSet:"Assemblies.ClearanceSet"}},2,0],[["object1","object2","text"],"SetInterferenceText",{},3,0],[["doCleanupNow"],"DetectObsoleteSettings",{R_:{containsObsoleteSettings:''}},1,0],[[],"DeleteAllInterferences",{},0,0],[["object1","object2"],"GetInterferenceStatus",{R_:{status:''}},2,0],[["object1","object2","status"],"SetInterferenceStatus",{},3,0],[["firstObjects","secondObjects"],"ExcludePairs",{},2,0],[["object1","object2","markOutOfDate"],"DeleteExcludedPair",{},3,0],[["object1","object2"],"GetExcludedPairText",{R_:{text:''}},2,0],[["object1","object2","text"],"SetExcludedPairText",{},3,0],[["firstObjects","secondObjects"],"MarkExcludedPairsUpToDate",{},2,0]],[]];
SPLM.Assemblies.ClearanceSet = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.ClearanceSet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.ClearanceSet.Summary = class{
    constructor(startTime,endTime,runTime,version,analysisMode,numCollections,numCollection1,numCollection2,numPairs,numExcludedPairs,numChangedPairs,numChangedObjs,numCheckedPairs,numNewHard,numNewSoft,numNewTouching,numNewContainment,numNewAllInterf,numHard,numSoft,numTouching,numContainment,numAllInterf,jobStatus,numZones){
        this.startTime=startTime;this.endTime=endTime;this.runTime=runTime;this.version=version;this.analysisMode=analysisMode;this.numCollections=numCollections;this.numCollection1=numCollection1;this.numCollection2=numCollection2;this.numPairs=numPairs;this.numExcludedPairs=numExcludedPairs;this.numChangedPairs=numChangedPairs;this.numChangedObjs=numChangedObjs;this.numCheckedPairs=numCheckedPairs;this.numNewHard=numNewHard;this.numNewSoft=numNewSoft;this.numNewTouching=numNewTouching;this.numNewContainment=numNewContainment;this.numNewAllInterf=numNewAllInterf;this.numHard=numHard;this.numSoft=numSoft;this.numTouching=numTouching;this.numContainment=numContainment;this.numAllInterf=numAllInterf;this.jobStatus=jobStatus;this.numZones=numZones;}
    get Starttime(){return this.startTime}
    set Starttime(val){this.startTime = val}
    get Endtime(){return this.endTime}
    set Endtime(val){this.endTime = val}
    get Runtime(){return this.runTime}
    set Runtime(val){this.runTime = val}
    get Version(){return this.version}
    set Version(val){this.version = val}
    get Analysismode(){return this.analysisMode}
    set Analysismode(val){this.analysisMode = val}
    get Numcollections(){return this.numCollections}
    set Numcollections(val){this.numCollections = val}
    get Numcollection1(){return this.numCollection1}
    set Numcollection1(val){this.numCollection1 = val}
    get Numcollection2(){return this.numCollection2}
    set Numcollection2(val){this.numCollection2 = val}
    get Numpairs(){return this.numPairs}
    set Numpairs(val){this.numPairs = val}
    get Numexcludedpairs(){return this.numExcludedPairs}
    set Numexcludedpairs(val){this.numExcludedPairs = val}
    get Numchangedpairs(){return this.numChangedPairs}
    set Numchangedpairs(val){this.numChangedPairs = val}
    get Numchangedobjs(){return this.numChangedObjs}
    set Numchangedobjs(val){this.numChangedObjs = val}
    get Numcheckedpairs(){return this.numCheckedPairs}
    set Numcheckedpairs(val){this.numCheckedPairs = val}
    get Numnewhard(){return this.numNewHard}
    set Numnewhard(val){this.numNewHard = val}
    get Numnewsoft(){return this.numNewSoft}
    set Numnewsoft(val){this.numNewSoft = val}
    get Numnewtouching(){return this.numNewTouching}
    set Numnewtouching(val){this.numNewTouching = val}
    get Numnewcontainment(){return this.numNewContainment}
    set Numnewcontainment(val){this.numNewContainment = val}
    get Numnewallinterf(){return this.numNewAllInterf}
    set Numnewallinterf(val){this.numNewAllInterf = val}
    get Numhard(){return this.numHard}
    set Numhard(val){this.numHard = val}
    get Numsoft(){return this.numSoft}
    set Numsoft(val){this.numSoft = val}
    get Numtouching(){return this.numTouching}
    set Numtouching(val){this.numTouching = val}
    get Numcontainment(){return this.numContainment}
    set Numcontainment(val){this.numContainment = val}
    get Numallinterf(){return this.numAllInterf}
    set Numallinterf(val){this.numAllInterf = val}
    get Jobstatus(){return this.jobStatus}
    set Jobstatus(val){this.jobStatus = val}
    get Numzones(){return this.numZones}
    set Numzones(val){this.numZones = val}
};

SPLM.Assemblies.ClearanceSet.ReanalyzeOutOfDateExcludedPairs = Object.freeze({
    "CustomerDefault" : "CustomerDefault", "True" : "True", "False" : "False"});

SPLM.Assemblies.ClearanceSet.JobStatus = Object.freeze({
    "NotAborted" : "NotAborted", "AbortedByUser" : "AbortedByUser", "AbortedOnError" : "AbortedOnError"});

SPLM.Assemblies.ClearanceSet.CopyMode = Object.freeze({
    "NoResults" : "NoResults", "Results" : "Results", "InterfBodies" : "InterfBodies"});

SPLM.Assemblies.ClearanceSet.ReanalyzePairCalculationMethod = Object.freeze({
    "UseStoredMethod" : "UseStoredMethod", "Lightweight" : "Lightweight", "ExactIfLoaded" : "ExactIfLoaded", "Exact" : "Exact"});

SPLM.Assemblies.ClearanceSet.InterferenceType = Object.freeze({
    "Soft" : "Soft", "Touch" : "Touch", "Hard" : "Hard", "Cont1In2" : "Cont1In2", "Cont2In1" : "Cont2In1", "NoInterference" : "NoInterference"});

SPLM.Assemblies.ClearanceSet.PenetrationDepthResult = Object.freeze({
    "NotAttempted" : "NotAttempted", "Success" : "Success", "NoClash" : "NoClash", "Touching" : "Touching", "BothSheets" : "BothSheets", "UnspecifiedError" : "UnspecifiedError"});

SPLM.Assemblies.ClearanceSet.InterferenceStatus = Object.freeze({
    "Undetermined" : "Undetermined", "Resolved" : "Resolved", "Irrelevant" : "Irrelevant", "Pending" : "Pending"});

export default SPLM;